import BaseDecorator from "./BaseDecorator";

export default class CompanyMemberDecorator extends BaseDecorator {
  static ROLES = ["global_admin", "main_admin", "editor_admin", "company_admin", "company_employee"];

  static get role_options() {
    return this.ROLES.map((role) => [role, I18n.humanAttributeName("company_member", role)]);
  }

  get role_i18n() {
    return this.role && I18n.humanAttributeName("company_member", this.role);
  }

  get st_admin() {
    return ["global_admin", "main_admin", "editor_admin"].includes(this.role);
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/CompanyMemberDecorator.js